export const DayFormat = 'MM/DD/YYYY'
